<template>
  <div
    ref="nearestSearchesContainerRef"
    class="no-scrollbar flex overflow-auto"
  >
    <button
      v-for="search in searchesList"
      :key="search.departureDate"
      ref="nearestSearchesListRef"
      type="button"
      class="flex w-[100px] shrink-0 flex-col items-center space-y-1 p-2"
      :class="{
        'js-active-nearby-price bg-background-neutral-secondary border-background-positive-primary rounded-xl border-2':
          search.isActive,
      }"
      @click="emit('onDateSelect', search.departureDate)"
    >
      <p class="text-text-neutral-quaternary text-xs font-medium">
        {{ dateUtils.getFormattedDateAndWeekDay(search.departureDate) }}
      </p>
      <p
        v-if="search.price !== null"
        v-price="search.price"
        class="whitespace-nowrap text-base font-semibold"
        :class="{
          'text-text-neutral-primary': !search.isMinPrice,
          'text-text-positive-primary': search.isMinPrice,
        }"
      />
      <!-- prettier-ignore -->
      <svg
        v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
        :class="search.isActive ? 'text-text-neutral-primary' : 'text-situational-grey'"
      >
        <path fill="currentColor" fill-rule="evenodd" d="M8.333 3.25a5.083 5.083 0 1 0 0 10.166 5.083 5.083 0 0 0 0-10.166ZM1.75 8.333a6.583 6.583 0 1 1 13.166 0 6.583 6.583 0 0 1-13.166 0Z" clip-rule="evenodd"/>
        <path fill="currentColor" fill-rule="evenodd" d="M11.97 11.97a.75.75 0 0 1 1.061 0l5 5a.75.75 0 0 1-1.06 1.061l-5-5a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { dateUtils } from 'shared';
  import { useHorizontalScrollToActive } from 'freedom-shared';

  import type { MappedNearestSearch } from '../types';

  const props = defineProps<{ searchesList: MappedNearestSearch[] }>();
  const emit = defineEmits<{ onDateSelect: [date: string] }>();

  const nearestSearchesContainerRef = ref<HTMLDivElement | null>(null);
  const nearestSearchesListRef = ref<Array<HTMLButtonElement> | null>(null);

  useHorizontalScrollToActive(
    nearestSearchesContainerRef,
    nearestSearchesListRef,
    {
      activeClass: 'js-active-nearby-price',
    },
  );
</script>
